import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const PunchToolIcon = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 32 32", strokeWidth: "1.33", ...rest, children: _jsx("circle", { cx: "16", cy: "16", r: "8", fill: "currentColor" }) }));
};
export default PunchToolIcon;
//# sourceMappingURL=PunchToolIcon.js.map